import { usePlug } from "lib/@components/slot/use-plug"
import { clearRightBarRefreshers, filterRightBarToAuthoringTabs } from "../lib/right-bar-filters"

export function useScheduleEditorRightBarPlugs() {
    usePlug("ScheduleRightBar-Tab", filterRightBarToAuthoringTabs, [])
    usePlug("ScheduleRightBar-Panel", filterRightBarToAuthoringTabs, [])
    usePlug("ScheduleRightBar-Refresh", clearRightBarRefreshers, [])
}
